/**
 * Subscriptions per-sub-nav access model — mirrors the analytics one so specific
 * people can be given some sub-navs (e.g. the ones Frank builds) but NOT others
 * (e.g. Revenue, which is financial). Deny-by-default per page.
 *
 * Roles on top of `tools.subscriptions.enabled`:
 *  - ADMIN  (`tools.subscriptions.role` ∈ {admin, approver_admin}, or app admin)
 *    — sees every sub-nav (for building/validating).
 *  - VIEWER (enabled, not admin) — sees ONLY the pages granted in
 *    `user.subscriptionPages` (nothing until granted).
 *
 * GRANTING page access is APP-ADMIN ONLY (see functions/callables/
 * subscriptionAccess.ts) — deliberately tighter than analytics, because handing
 * out the Revenue page = handing out financial data.
 *
 * CONVENTION: every provisionable sub-nav has a stable `key` here; the web
 * registry (web/src/subscriptions/registry.tsx) carries the same key. Add a new
 * sub-nav → add its key here so it's provisionable.
 */
/** The provisionable Subscriptions sub-navs (NOT the admin Access page). */
export const SUBSCRIPTION_PAGES = [
    { key: 'revenue', label: 'Revenue' },
    { key: 'types', label: 'Plan types' },
    { key: 'deep-dive', label: 'Revenue deep dive' },
    { key: 'churn', label: 'Churn deep dive' },
    { key: 'churn-list', label: 'Churn list' },
    { key: 'health', label: 'Health' },
    { key: 'insights', label: 'Insights' },
    { key: 'user-performance', label: 'User Performance' },
    { key: 'audio', label: 'Audio' },
    { key: 'stats', label: 'Stats' },
    { key: 'conversion', label: 'Conversion' },
    { key: 'promotions', label: 'Promotions' },
];
export const SUBSCRIPTION_PAGE_KEYS = SUBSCRIPTION_PAGES.map((p) => p.key);
/** Sees every sub-nav = app admin OR an admin-flavored subscriptions tool role. */
export function isSubscriptionAdmin(opts) {
    return opts.isAppAdmin || opts.role === 'admin' || opts.role === 'approver_admin';
}
/** Can this user see a given sub-nav? Admins → all; viewers → granted only. */
export function canViewSubscriptionPage(admin, granted, key) {
    if (admin)
        return true;
    return (granted ?? []).includes(key);
}
/** The sub-nav keys this user can see (admins = all). */
export function visibleSubscriptionPages(admin, granted) {
    return admin ? SUBSCRIPTION_PAGE_KEYS : (granted ?? []).filter((k) => SUBSCRIPTION_PAGE_KEYS.includes(k));
}
//# sourceMappingURL=subscriptionPages.js.map